import { Button } from "primereact/button"
import React, { Fragment, useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import FormDropdown from "../../component/dropdown/formDropdown"
import Forminputtext from "../../component/inputtext/forminputtext"
import PopUpScreen from "../../component/popUpScreen/popUpScreen"
import { FieldLabel } from "../global/global.style"
import { InputNumber } from 'primereact/inputnumber';
import { RESET_FORM_VALUE } from "../../redux/dataAsset/dataAsset.type"
import { editAssetLevelRule, editColumnLevelRule } from "../../redux/dataAsset/dataAsset.action"
import { LabelWrapper } from "../../component/inputtext/inputtextStyle"
import ErrorMessage from "../../component/errorMessage/errorMsg"
import { Tooltip } from "primereact/tooltip"
import { theme } from "../../theme/theme"
import FormInputDescription from "../../component/inputtext/formInputDescription"

function EditRule({ dataAssetId, editObjectId, ruleType, onHide, changeDetail }) {
    const { formData } = useSelector((state) => state.dataAsset)
    const dispatch = useDispatch()
    const toast = useRef(null);
    const [ruleDescription, setRuleDescription] = useState("");
    const [thresholdType, setThresholdType] = useState("");
    const [thresholdValue, setThresholdValue] = useState("");
    const [isActive, setIsActive] = useState("")
    const [ruleName, setRuleName] = useState("")
    const [checkExpression, setCheckExpression] = useState("")
    const [dimension, setDimension] = useState("")
    const [checkType, setCheckType] = useState("")
    const [check, setCheck] = useState("")
    const [expression, setExpression] = useState("");
    const [driftType, setDriftType] = useState("");
    const [driftValue, setDriftValue] = useState("");
    const [driftPercentage,setDriftPercentage] = useState("")
    const [driftWindow, setDriftWindow] = useState("")


    useEffect(() => {
        if (ruleType === "Column Level Rules") {
            let obj = formData.configureColumnDQRuleform.options.filter((val) => val.id === editObjectId)[0]
            setExpression(obj.expression)
            setCheckExpression(obj.check_expression)
            setRuleName(obj.rules_name)
            setDimension(obj.dimension)
            setCheckType(obj.dq_rule_check)
            setRuleDescription(obj.rule_description)
            setThresholdType(obj.threshold_type)
            setThresholdValue(obj.threshold_value)
            setIsActive(obj.is_active)
            setDriftType(obj.drift_type)
            setDriftPercentage(obj.drift_value)
            setDriftValue(obj.drift_value)
            setDriftWindow(obj.drift_window)
        } else if (ruleType === "Asset Level Rules") {
            let obj = formData.configureAssetDQRuleform.options.filter((val) => val.id === editObjectId)[0]
            setRuleName(obj.rules_name)
            setDimension(obj.dimension)
            setCheckType(obj.check_name)
            setRuleDescription(obj.rule_description)
            setThresholdType(obj.threshold_type)
            setThresholdValue(obj.threshold_value)
            setIsActive(obj.is_active)
            setExpression(obj.expression)
            obj.drift_type==='Percentage'?setDriftPercentage(obj.driftValue):setDriftValue(obj.driftValue)
            // setDriftValue()
            // alert(obj.driftPercentage)
            setDriftType(obj.drift_type)
            setDriftWindow(obj.driftWindow)
        }
    }, [])
    return <PopUpScreen style={{ width: "70%" }} header={ruleName} onHide={() => {
        onHide()
    }}
    >
        {ruleType === "Column Level Rules" ? <Fragment>

            <div className="grid">
                <div className="col-6" >
                    <Forminputtext style={{ width: "100%", height: "40px" }} placeholder="Rule Description" label={<div>Rule Description <Tooltip target=".custom-target-icon" />
                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                            data-pr-tooltip={"Enter a brief description explaining the purpose and function of the rule."}
                            data-pr-position="top"
                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                        ></i>
                    </div>} name="ruleDescription" value={ruleDescription} onChange={(e) => setRuleDescription(e.target.value)} />

                </div>
                <div className="col-6" >
                    <Forminputtext
                        disabled
                        style={{ width: "100%" }}
                         label={<div>Dimension <span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Choose the data dimension that will be monitored for changes (e.g., completeness, uniqueness)."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="dimension" value={dimension} required={false}
                       />
                </div>
            </div>
            <div className="grid">
                <div className="col-6" >
                    <div className="grid">

                        <div className="col-6" >
                            <Forminputtext
                                disabled
                                style={{ width: "100%" }} label={<div>Check Type<span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                        data-pr-tooltip={"Select the type of check to apply (e.g., anomaly detection, range validation)."}
                                        data-pr-position="top"
                                        style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                    ></i>
                                </div>}
                                name="check_type" value={checkType} required={false}
                           
                            />
                        </div>
                        <div className="col-6" >
                            
                            <Forminputtext
                                disabled
                                style={{ width: "100%" }}  label={<div>Check
                                    <Tooltip target=".custom-target-icon" />
                                </div>}
                                name="dataAssetChecks" placeholder="" value={checkExpression} required={false}
                           
                            />
                        </div>
                    </div>
                </div>
                <div className="col-6" >
                    <Forminputtext
                        disabled={dimension === "drift" || (dimension === "uniqueness" && checkType === "duplicate_check") || (dimension === "completeness" && checkType === "null_check")} style={{ width: "100%", marginBottom: "8px", height: "40px" }} placeholder="Expression" label={<div>Expression <Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Specify the acceptable values for the selected column to maintain data consistency."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="validValues" value={expression} required={false} onChange={(e) => setExpression(e.target.value)} />
                </div>
            </div>
            <div className="grid">
                <div className="col-6" >
                    <div className="grid">
                        <div className="col-6" >
                            <FormDropdown disabled={dimension !== "drift"} style={{ width: "100%" }} options={formData.drift_type.options} optionLabel="name" placeholder="Drift Type" label={<div>Drift Type

                            </div>} name="drift_type" value={{name:driftType}}
                            onChange={(e) => setDriftType(e.target.value.name)}
                            />
                           
                        </div>
                        <div className="col-6" >
                            {driftType === "Percentage" ? <Fragment><label htmlFor="driftper" >
                                <LabelWrapper>
                                    <FieldLabel>Drift Value
                                        <Tooltip target=".custom-target-icon" />
                                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                            data-pr-tooltip={"Define the allowable percentage change in data distribution before triggering an alert."}
                                            data-pr-position="top"
                                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                        ></i>
                                    </FieldLabel>
                                </LabelWrapper>
                            </label>
                                <InputNumber
                                    disabled={dimension !== "drift"}
                                    inputId="driftper"
                                    name="driftPercentage"
                                    value={driftPercentage}
                                    onValueChange={(e) => setDriftPercentage( e.target.value)}
                                    // showButtons
                                    step={1}
                                    min={0}
                                    max={100}
                                    style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                                /></Fragment> : <Fragment>
                                <LabelWrapper>
                                    <FieldLabel>Drift Value
                                        <Tooltip target=".custom-target-icon" />
                                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                            data-pr-tooltip={"Specify the expected or allowable drift value to monitor changes in data patterns."}
                                            data-pr-position="top"
                                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                        ></i>
                                    </FieldLabel>
                                </LabelWrapper>
                                <InputNumber
                                    disabled={dimension !== "drift"}
                                    name="driftValue"
                                    value={driftValue}
                                    onValueChange={(e) => setDriftValue(e.target.value)}
                                    // showButtons
                                    step={1}
                                    min={0}
                                    style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                                />
                            </Fragment>}
                        </div>
                    </div>
                </div>
                <div className="col-6" >
                    <label htmlFor="driftwindow" >
                        <LabelWrapper>
                            <FieldLabel>Drift Window (in days)
                                <Tooltip target=".custom-target-icon" />
                                <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                    data-pr-tooltip={"Set the time window (in days) over which data drift will be evaluated."}
                                    data-pr-position="top"
                                    style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                ></i>
                            </FieldLabel>
                        </LabelWrapper>
                    </label>
                    <InputNumber
                        disabled={dimension !== "drift"}
                        inputId="driftwindow"
                        value={driftWindow}
                        name="driftWindow"
                        onValueChange={(e) => setDriftWindow(e.value)}
                        showButtons
                        step={1}
                        min={0}
                        max={100}
                        style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                    />
                </div>
            </div>
            <div className="grid">

                <div className="col-6" >

                    <FormDropdown
                        disabled={dimension === "drift" || (dimension === "validity" && (checkType === "date_format_check" || checkType === "datetime_format_check" || checkType === "email_validation_check" ))}
                        style={{ width: "100%" }} options={formData.threshold_type.options} optionLabel="name" placeholder="Threshold Type" label={<div>Threshold Type<Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Select the type of threshold (e.g., count, percentage) to define the acceptable limits."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="threshold_type" valueAsObj={{name:thresholdType}} required={false}
                    onChange={(e) => setThresholdType(e.target.value.name)}
                    />
                </div>
                <div className="col-6" >
                    <label htmlFor="threshold" > <LabelWrapper><FieldLabel>Threshold
                        <Tooltip target=".custom-target-icon" />
                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                            data-pr-tooltip={" Enter the threshold value that determines acceptable variance for the rule."}
                            data-pr-position="top"
                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                        ></i>

                    </FieldLabel></LabelWrapper></label>

                    <InputNumber
                        disabled={thresholdType === "" || thresholdType === null || dimension === "drift" || (dimension === "validity" && (checkType === "date_format_check" || checkType === "datetime_format_check" || checkType === "email_validation_check"))}
                        inputId="threshold"
                        value={thresholdValue}
                        name="threshold"
                        onValueChange={(e) => setThresholdValue(e.value)}
                        showButtons
                        step={1}
                        min={0}
                        max={100}
                        style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                    />


                </div>
            </div>
        </Fragment> : ruleType === "Asset Level Rules" ? <Fragment>
            <div className="grid">
                <div className="col-6" >
                    <Forminputtext
                        style={{ width: "100%" }} label={<div>Dimension <span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Choose the data dimension that will be monitored for changes (e.g., completeness, uniqueness)."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="dimension" value={dimension} required={false}
                  
                    />
                </div>
                <div className="col-6" >
                    <div className="grid">
                        <div className="col-6" >
                            <Forminputtext
                            disabled
                                style={{ width: "100%" }} label={<div>Check <span style={{ color: "#f10000" }}>* </span><Tooltip target=".custom-target-icon" />
                                    <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                        data-pr-tooltip={"Select the type of check to apply (e.g., anomaly detection, range validation)."}
                                        data-pr-position="top"
                                        style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                    ></i>
                                </div>} name="check_type" value={checkType} required={false}
                           
                            />

                        </div>
                       
                    </div>

                </div>
            </div>
            <div className="grid">

                <div className="col-6" >
                    <Forminputtext style={{ width: "100%", height: "40px" }} placeholder="Rule Description" label={<div>Rule Description<Tooltip target=".custom-target-icon" />
                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                            data-pr-tooltip={"Enter a brief description explaining the purpose and function of the rule."}
                            data-pr-position="top"
                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                        ></i>
                    </div>} name="ruleDescription" value={ruleDescription}
                     onChange={(e) => setRuleDescription(e.target.value)} 
                    />
                    <div className="grid" style={{ marginTop: "2px" }}>
                        <div className="col-6" >
                            <FormDropdown
                                disabled={dimension!== "drift"}
                                style={{ width: "100%" }} options={formData.drift_type.options} optionLabel="name" placeholder="Drift Type" label={<div>Drift Type

                                </div>} name="drift_type" value={{name:driftType}}
                             onChange={(e) => setDriftType(e.target.value.name)} 
                            />
                        </div>
                        <div className="col-6" >
                            {driftType === "Percentage" ? <Fragment><label htmlFor="driftper" >
                                <LabelWrapper>
                                    <FieldLabel>Drift Value
                                        <Tooltip target=".custom-target-icon" />
                                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                            data-pr-tooltip={"Define the allowable percentage change in data distribution before triggering an alert."}
                                            data-pr-position="top"
                                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                        ></i>
                                    </FieldLabel>
                                </LabelWrapper>
                            </label>
                                <InputNumber
                                    disabled={dimension !== "drift"}
                                    inputId="driftper"
                                    name="driftPercentage"
                                    value={driftPercentage}
                                    onValueChange={(e) => setDriftPercentage(e.value)}
                                    // showButtons
                                    step={1}
                                    min={0}
                                    max={100}
                                    style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                                /></Fragment> : <Fragment>
                                <LabelWrapper>
                                    <FieldLabel>Drift Value
                                        <Tooltip target=".custom-target-icon" />
                                        <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                            data-pr-tooltip={"Specify the expected or allowable drift value to monitor changes in data patterns."}
                                            data-pr-position="top"
                                            style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                        ></i>
                                    </FieldLabel>
                                </LabelWrapper>
                                <InputNumber
                                    disabled={dimension !== "drift"}
                                    name="driftValue"
                                    value={driftValue}
                                    onValueChange={(e) => setDriftValue(e.value)}
                                    // showButtons
                                    step={1}
                                    min={0}
                                    style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                                />
                            </Fragment>}

                        </div>
                    </div>
                    <label htmlFor="driftwindow" >
                        <LabelWrapper>
                            <FieldLabel>Drift Window (in days)
                                <Tooltip target=".custom-target-icon" />
                                <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                    data-pr-tooltip={"Set the time window (in days) over which data drift will be evaluated."}
                                    data-pr-position="top"
                                    style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                                ></i>
                            </FieldLabel>
                        </LabelWrapper>
                    </label>
                    <InputNumber
                        disabled={dimension !== "drift"}
                        inputId="driftwindow"
                        value={driftWindow}
                        name="driftWindow"
                        onValueChange={(e) => setDriftWindow(e.value)}
                        showButtons

                        step={1}
                        min={0}
                        max={100}
                        style={{ background: "#f3f4f6", width: "100%", height: "40px" }}
                    />
                </div>
                <div className="col-6" >
                    <Fragment><FormInputDescription
                        disabled={
                            (
                                dimension === "validity" &&
                               checkType === "custom_sql_check"
                            ) ||
                                (
                                    dimension === "consistency" &&
                                    checkType === "schema_check"
                                )
                                ? false
                                : true
                        } placeholder="Write Expression..." style={{ width: "100%", height: "89%" }} label={<div>Expression<Tooltip target=".custom-target-icon" />
                            <i className="custom-target-icon pi pi-info-circle p-text-secondary p-overlay-badge"
                                data-pr-tooltip={"Specify the acceptable values for the selected column to maintain data consistency."}
                                data-pr-position="top"
                                style={{ marginLeft: "10px", cursor: 'pointer', color: theme.colors.primary }}
                            ></i>
                        </div>} name="expression" value={expression}
                    onChange={(e) => setExpression(e.target.value)} 
                    />
                    </Fragment>

                </div>
            </div>
        </Fragment> : ""
        }



        <div className="grid">
            <div className="col-12" style={{ marginTop: "10px", textAlign: "right" }} >
                <Button style={{ width: "100px", textAlign: "center", marginRight: "10px" }} outlined label="Cancel" onClick={() => {
                    dispatch({
                        type: RESET_FORM_VALUE
                    })
                    onHide()
                }} />
                <Button style={{ width: "100px", textAlign: "center" }} label="Save" onClick={() => {
                    if (ruleType === "Asset Level Rules") {
                        dispatch(editAssetLevelRule(editObjectId, dataAssetId, ruleDescription, thresholdValue, thresholdType, isActive, driftValue, driftWindow,driftType,driftPercentage,expression))
                    } else if (ruleType === "Column Level Rules") {
                        dispatch(editColumnLevelRule(editObjectId, dataAssetId, ruleDescription, thresholdValue, thresholdType, isActive,(driftType==='Percentage'?driftPercentage:driftValue),driftType,expression,checkExpression))
                    }
                    onHide()
                }} />

            </div>
        </div>
    </PopUpScreen>
}
export default EditRule